<template>
  <div>
    <!-- 导航 -->
    <el-breadcrumb>
      <el-breadcrumb-item>
        <router-link to="/">首页</router-link>
      </el-breadcrumb-item>
      <el-breadcrumb-item>课程管理</el-breadcrumb-item>
    </el-breadcrumb>

    <!-- 搜索 -->
    <div class="content">
      <el-form
        inline
        :model="query"
        label-width="60px"
        label-position="right"
        size="small"
        class="query-form"
        @submit.native.prevent="getList()"
      >
        <el-form-item label="搜索">
          <el-input v-model="query.key" placeholder="请输入关键词"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="selList()">查询</el-button>
          <el-button type="success" @click="dialogVisible=true;form={isEnable:true,courseName:''};">新增</el-button>
        </el-form-item>
      </el-form>

      <!-- 主体 -->
      <el-card class="box-card table">
        <div class="clearfix" slot="header">
          <span>课程列表</span>
        </div>

        <!-- 列表 -->
        <el-table
          v-loading="loading"
          :data="tableData"
          ref="tableData"
          border
          stripe
          style="width:100%"
          @sort-change="sortChange"
          @filter-change="filterTag"
        >
          <el-table-column prop="japName" label="姓名"></el-table-column>
          <el-table-column prop="courseName" label="课程名称"></el-table-column>
          <el-table-column prop="coursePrice" label="课程费用"></el-table-column>
          <el-table-column prop="payTime" label="缴费时间"></el-table-column>
          <el-table-column prop="teacherNames" label="讲师名字"></el-table-column>
          <el-table-column prop="classHour" label="课时数"></el-table-column>
          <el-table-column prop="classForm" label="上课形式"></el-table-column>
          <el-table-column prop="createTime" label="操作时间"></el-table-column>

          <!-- 操作 -->
          <el-table-column label="操作" width="80" fixed="right">
            <template slot-scope="scope">
              <el-button-group>
                <el-tooltip content="编辑" placement="top">
                  <el-button
                    type="primary"
                    size="mini"
                    icon="el-icon-edit"
                    @click="editClick(scope.row)"
                  ></el-button>
                </el-tooltip>
                <el-tooltip content="删除" placement="top">
                  <el-button
                    type="warning"
                    size="mini"
                    icon="el-icon-delete"
                    @click="delClick(scope.row)"
                  ></el-button>
                </el-tooltip>
              </el-button-group>
            </template>
          </el-table-column>
        </el-table>

        <!-- 分页 -->
        <div class="block" style="margin-top:20px;">
          <el-pagination
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :size-page="pageSize"
            :current-page="currentPage4"
            :page-sizes="[10,20,30,50,100]"
            layout="total,sizes,prev,pager,next,jumper"
            :total="total"
          ></el-pagination>
        </div>
      </el-card>
    </div>

    <!-- 弹框 -->
    <el-dialog :title="form.id>0?'编辑课程':'添加课程'" :visible.sync="dialogVisible">
      <el-form
        :model="form"
        ref="form"
        label-width="100px"
        :status-icon="true"
        @submit.native.prevent="submitForm(form)"
      >
        <!-- <el-row :gutter="20">
          <el-col :span="10"> -->
            <el-form-item prop="courseName" label="购买课程">
              <el-input v-model="form.courseName" placeholder="请输入课程名称"></el-input>
            </el-form-item>
          <!-- </el-col>
        </el-row> -->

        <el-form-item prop="payTime" label="缴费时间" :rules="[{required:true,message:'不能为空'}]">
          <el-date-picker
            v-model="form.payTime"
            value-format="yyyy-MM-dd"
            type="date"
            placeholder="请选择时间"
          ></el-date-picker>
        </el-form-item>

        <el-form-item prop="coursePrice" label="全额费用">
          <el-input-number v-model="form.coursePrice" :min="0" :precision="2" :step="0.01" :controls="true" placeholder="请输入全额费用" style="width:100%"></el-input-number>
        </el-form-item>

        <el-row :gutter="24">
          <el-col :span="8">
            <el-form-item prop="amount1" label="一期">
              <el-input-number v-model="form.amount1" :min="0" :precision="2" :step="0.01" style="width:100%"></el-input-number>
            </el-form-item>
            <el-form-item prop="phase1Date" label="一期日期">
              <el-date-picker v-model="form.phase1Date" value-format="yyyy-MM-dd" type="date" placeholder="请选择日期" style="width:100%"></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item prop="amount2" label="二期">
              <el-input-number v-model="form.amount2" :min="0" :precision="2" :step="0.01" style="width:100%"></el-input-number>
            </el-form-item>
            <el-form-item prop="phase2Date" label="二期日期">
              <el-date-picker v-model="form.phase2Date" value-format="yyyy-MM-dd" type="date" placeholder="请选择日期" style="width:100%"></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item prop="amount3" label="三期">
              <el-input-number v-model="form.amount3" :min="0" :precision="2" :step="0.01" style="width:100%"></el-input-number>
            </el-form-item>
            <el-form-item prop="phase3Date" label="三期日期">
              <el-date-picker v-model="form.phase3Date" value-format="yyyy-MM-dd" type="date" placeholder="请选择日期" style="width:100%"></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>

        <!-- <el-form-item prop="percentage" label="顾问提成" :rules="[{required:true,message:'不能为空'}]">
          <el-input type="number" v-model.number="form.percentage" placeholder="请输入数字"></el-input>
        </el-form-item> -->

        <el-form-item prop="classHour" label="课时数" :rules="[{required:true,message:'不能为空'}]">
          <el-input type="number" v-model.number="form.classHour" placeholder="请输入课时"></el-input>
        </el-form-item>
        <el-form-item label="上课形式">
          <el-select v-model="form.classForm" placeholder="请选择上课形式" style="width: 100%;">
            <el-option label="线下课" value="线下课"></el-option>
            <el-option label="网课" value="网课"></el-option>
            <el-option label="录播课" value="录播课"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="startTime" label="开始时间" :rules="[{required:true,message:'不能为空'}]">
          <el-date-picker
            v-model="form.startTime"
            value-format="yyyy-MM-dd"
            type="date"
            placeholder="请选择开始时间"
          ></el-date-picker>
        </el-form-item>

        <el-form-item prop="endTime" label="结束时间" :rules="[{required:true,message:'不能为空'}]">
          <el-date-picker
            v-model="form.endTime"
            value-format="yyyy-MM-dd"
            type="date"
            placeholder="请选择结束时间"
          ></el-date-picker>
        </el-form-item>

        <el-form-item label="教学老师">
          <el-select
            v-model="teacherOptions"
            placeholder="请选择教学老师"
            multiple
            clearable
            style="width:100%"
          >
            <el-option
              v-for="item in teacherlist"
              :label="item.realName"
              :value="item.userID"
              :key="item.userID"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" :loading="submiting" native-type="submit">提交</el-button>
          <el-button @click="dialogVisible=false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import DeptRoleTeacherSelect from "@/components/DeptRoleTeacherSelect.vue";
import url from "@/plugins/urlHelper.js";
export default {
  data() {
    return {
      japid: 0,
      query: {},
      form: {},
      submiting: false,
      loading: false,
      dialogVisible: false,
      tableData: [],
      total: 0,
      pageSize: 10,
      currentPage4: 1,
      courselist: [], //课程
      teacherlist: [], //教师
      teacherOptions: []
    };
  },
  methods: {
    handleSizeChange: function(val) {
      this.pageSize = val;
      this.currentPage4 = 1;
      this.getList();
    },
    handleCurrentChange: function(val) {
      this.currentPage4 = val;
      this.getList();
    },
    // 排序
    sortChange: function(sortColumn) {
      this.query.sort = sortColumn.sort;
      this.query.order = sortColumn.order;
      this.getList();
    },
    // 筛序
    filterTag: function(filter) {
      var val = filter["isEnable"][0];
      this.form.isEnable = val;
      this.getList();
    },
    // 课程
    getCourseList: function() {
      var _this = this;
      var link = url.getJap("getall_course");
      $.get(link, {}, data => {
        _this.courselist = data;
      });
    },
    // 教师
    getTeacherList: function() {
      var _this = this;
      var link = url.getStu("getteacher");
      $.get(link, {}, data => {
        _this.teacherlist = data;
      });
    },
    // 列表
    getList: function() {
      var _this = this;
      _this.loading = true;
      var params = this.query;
      params.japid = _this.japid;
      params.pageSize = _this.pageSize;
      params.pageIndex = _this.currentPage4;
      var link = url.getJap("getlist_course");
      $.get(link, params, data => {
        _this.loading = false;
        _this.tableData = data.list;
        _this.total = data.total;
      });
    },
    // 查询
    selList: function() {
      this.currentPage4 = 1;
      this.getList();
    },
    // 编辑
    editClick: function(row) {
      var _this = this;
      var id = row.id;
      var link = url.getJap("getmodel_course");
      $.get(link, { id: id }, data => {
        _this.form = data;
        _this.dialogVisible = true;
        if (data.teachers) {
          _this.teacherOptions = data.teachers.split(",").map(Number);
        }
      });
    },
    // 删除
    delClick: function(row) {
      var _this = this;
      var id = row.id;
      var link = url.getJap("delete_course");

      this.$confirm("确定要删除吗？", "提示", {
        confirmButtonText: "确定",
        concelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          $.post(link, { id: id }, res => {
            if (res.status) {
              _this.dialogVisible = false;
              _this.getList();
              _this.$message({
                type: "success",
                message: res.msg
              });
            } else {
              _this.$message({
                type: "error",
                message: res.msg
              });
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消"
          });
        });
    },
    // 提交
    submitForm: function(formName) {
      var _this = this;
      var link = url.getJap("addorupdate_course");
      var info = Object.assign({}, this.form);
      info.japid = this.japid;
      info.teachers = this.teacherOptions.join();
      info.marketPercentage = 0;
      // 缴费金额：确保以数字提交，便于后端绑定与 VIP 列表回显
      info.amount1 = Number(this.form.amount1) || 0;
      info.amount2 = Number(this.form.amount2) || 0;
      info.amount3 = Number(this.form.amount3) || 0;
      delete info.jap_Info;
      delete info.teacherList;

      this.$refs.form.validate(valid => {
        if (valid) {
          this.submiting = true;

          // 提交后台  添加或修改
          $.post(link, info, res => {
            _this.submiting = false;
            if (res.status) {
              _this.dialogVisible = false;
              _this.getList();
              _this.form.state = 3;
              _this.$message({
                type: "success",
                message: res.msg
              });
            } else {
              _this.$message({
                type: "error",
                message: res.msg
              });
            }
          });
        } else {
          return false;
        }
      });
    }
  },
  mounted() {
    var _this = this;
    // 课程
    _this.getCourseList();
    // 教师
    _this.getTeacherList();
    //   接收参数
    _this.japid = this.$route.query.id;
    if (this.japid > 0) {
      this.getList();
    } else {
      _this.form = {};
    }
    // 列表
    _this.getList();
  }
};
</script>

<style scoped>
.query-form {
  margin-top: 20px;
  padding-top: 25px;
  background: #f2f2f2;
}
.el-input,
.el-select {
  width: 100%;
}
</style>